<template>
    <button
        class="tiptap-btn"
        type="button"
        :title="$t('Bold')"
        :disabled="disabled || !editor.can().chain().focus().toggleBold().run()"
        :class="{ 'is-active': editor.isActive('bold') }"
        @click="editor.chain().focus().toggleBold().run()">
        <FormatBoldIcon size="16"/>
    </button>
</template>

<script>
import FormatBoldIcon from '@/common/components/svg-icons/FormatBoldIcon.vue';
import {Editor} from '@tiptap/vue-2';

export default {
    name: 'MenuBarBoldButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FormatBoldIcon
    }
};
</script>
